<template>
  <div>
    <v-card>
      <v-data-table
        @click:row="selecionarPedido"
        item-key="_id"
        single-select
        fixed-header
        height="calc(100vh - 216px)"
        :headers="headers"
        :items="pedidos"
        :class="{'elevation-1': $vuetify.breakpoint.mdAndUp}"
        :search="search"
        :items-per-page="50"
        single-expand
        show-expand
        :loading="loading"
      >
        <template v-slot:top>
          <v-toolbar flat height="64px">
            <v-toolbar-title>Pedidos</v-toolbar-title>
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Localizar"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item._id="{ item }">
          <v-chip color="secondary lighten-4" v-if="item.sincronizado == 0">{{ item._id.slice(0, 5) }}</v-chip>
          <v-chip color="success lighten-1" v-if="item.sincronizado == 1 && item.cancelado==0">{{ item._id.slice(0, 5) }}</v-chip>
          <v-chip color="error lighten-1" v-if="item.sincronizado == 1 && item.cancelado==1">{{ item._id.slice(0, 5) }}</v-chip>
        </template>

        <template v-slot:item.data="{ item }">
          <span>{{ item.data | dataBR }}</span>
        </template>

        <template v-slot:item.valor_liquido="{ item }">
          <span>{{ item.valor_liquido | valorBR }}</span>
        </template>

        <template v-slot:item.data-table-expand="{ item }">
          <v-speed-dial
            v-if="item._id === selected"
            :v-model="fab"
            direction="left"
            transition="slide-x-reverse-transition"
            :style="$vuetify.breakpoint.xsOnly ? 'bottom: 8px' : 'bottom: 0px'"
          >
            <template v-slot:activator>
              <v-btn color="rgba(0, 0, 0, 0.4)" dark small fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>more_vert</v-icon>
              </v-btn>
            </template>
            <v-btn fab dark small color="green" @click="editarPedido">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn fab dark small color="red" @click="dialogoCancelarPedido=true" v-if="item.sincronizado==1 && item.cancelado==0">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-speed-dial>
          <div v-else :v-show="$vuetify.breakpoint.mdAndUp" style="width: 40px" />
        </template>
      </v-data-table>
      <v-btn
        fab
        dark
        small
        :color="$vuetify.theme.secondary"
        @click="adicionarPedido"
        absolute
        bottom
        class="mb-11 ml-4"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>

    <v-dialog v-model="dialogoCancelarPedido" scrollable persistent :overlay="false" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          Cancelar Pedido?
        </v-card-title>

        <v-card-text>
          <slot>O pedido selecionado será cancelado</slot>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoCancelarPedido-=false" :disabled="cancelando">Fechar</v-btn>
          <v-btn text color="primary" @click="cancelarPedido" :loading="cancelando" :disabled="cancelando">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../api/index.js";

export default {
  name: 'Pedidos',
  data() {
    return {
      fab: false,
      openDialog: false,
      loading: true,
      selected: "",
      search: "",
      pedidoSelecionado: null,
      dadosPedido: null,
      headers: [
        { text: "Numero", value: "_id", width: "150px" },
        { text: "Data", value: "data" },
        { text: "Cliente", value: "cliente.nomeRazaoSocial" },
        { text: "Valor", value: "valor_liquido" },
        { text: "", value: "data-table-expand" }
      ],
      pedidos: [],
      dialogoCancelarPedido: false,
      cancelando: false,
    };
  },
  created: function() {
    this.getPedidos();
  },
  methods: {
    adicionarPedido () {
      this.$store.commit("ZERARPEDIDO");
      this.$router.push('/pedidos/adicionar');
    },
    editarPedido() {
      this.$store.commit("SETARPEDIDO", this.pedidoSelecionado);
      this.$router.push('/pedidos/editar');
    },
    /* cancelarPedido() {
      this.$store.commit("showShowMessage", {
        title: "Cancelar Pedido",
        message: "Deseja cancelar este pedido?",
        subMessage: this.pedidoSelecionado.nomeCliente,
        buttons: {
          ok: {
            label: "Sim",
            visible: true,
            onClick: function() {
              api.cancelarPedido(this.pedidoSelecionado, data => {
                this.pedidos = this.pedidos.filter(
                  pedido => pedido._id !== this.pedidoSelecionado._id
                );
                this.pedidoSelecionado = null;
              });
            }.bind(this)
          },
          cancel: { label: "Não" }
        }
      });
    }, */
    cancelarPedido () {
      this.cancelando = true;
      api.cancelarPedido(this.pedidoSelecionado, data => {
        console.log(data);
        this.dialogoCancelarPedido = false;
        this.cancelando = false;
        this.getPedidos();
      });
    },
    selecionarPedido(item, row) {
      row.select(true);
      this.pedidoSelecionado = { ...item };
      this.selected = item._id;
    },
    getPedidos() {
      this.loading = true;
      api.getPedidos(
        data => {
          this.pedidos = data;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      );
    }
  }
};
</script>

<style>
/* .v-data-table {
  width: 100%;
}
.v-data-footer {
  margin-right: 0px !important;
  height: 64px !important;
}
.v-data-footer__select {
  display: none !important;
} */
/* .v-data-table--fixed-header {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
} */
/*. v-data-table td,
.v-data-table th {
  padding: 4px 16px !important;
} */
/* tr.v-data-table__selected,
tr.v-data-table__mobile-table-row__selected {
  background: rgba(0, 0, 0, 0.1) !important;
} */
/* tr.v-data-table__mobile-table-row {
  display: block !important;
  width: 100%;
  height: 100%;
} */
/* .v-speed-dial {
  position: absolute;
} */
/* .v-btn--floating {
  position: relative;
} */
</style>
